import { useEffect, useState } from 'react'
import useDirections from '../Hooks/useDirections'

function Directions({ lat, lng, dest }) {
  const [directions, findDirections] = useDirections()
  const [step, setStep] = useState(-1)

  const nextStep = () => {
    if (directions.length > 0) {
      if (step == directions.length - 1) {
        setStep(-1)
      } else {
        setStep(step + 1)
      }
    }
  }

  useEffect(() => {
    findDirections(lat, lng, dest.split(' ')[0])
  }, [lat, lng, dest])

  useEffect(() => {
    if (directions)
      setStep(0)
    else
      setStep(-1)
  }, [directions])

  if (directions.length == 0 || step == -1) {
    return <div/>
  }

  return (
    <div className={"directions-box"}>
      <div>
        <p>{directions[step].distance.text}</p>
        <p dangerouslySetInnerHTML={{__html: directions[step].html_instructions.replace("Walk your bicycle", "").replace("bicycle", "")}} />
      </div>
      <button onClick={nextStep} className={"directions-next-step-button"}>next</button>
    </div>
  )
}

export default Directions;